<template>
  <b-row
    v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
    class="content-header"
  >
    <!-- Content Left -->
    <b-col class="content-header-left mb-2" cols="12" md="4">
      <b-row class="breadcrumbs-top">
        <b-col cols="12">
          <h2 class="content-header-title float-left pr-1 mb-0">
            {{ $route.meta.pageTitle }}
          </h2>
          <div class="breadcrumb-wrapper">
            <b-breadcrumb>
              <b-breadcrumb-item to="/">
                <feather-icon
                  icon="HomeIcon"
                  size="16"
                  class="align-text-top"
                />
              </b-breadcrumb-item>
              <b-breadcrumb-item
                v-for="item in $route.meta.breadcrumb"
                :key="item.text"
                :active="item.active"
                :to="item.to"
              >
                {{ item.text }}
              </b-breadcrumb-item>
            </b-breadcrumb>
          </div>
        </b-col>
      </b-row>
    </b-col>

    <!-- Content Right -->
    <b-col
      v-if="$route.meta.breadcrumbType == 'date'"
      class="content-header-right text-md-center d-md-block d-none mb-1"
      md="8"
      cols="12"
    >
      <b-row class="justify-content-end">
        <b-col cols="3">
          <Select2
              placeholder="Main"
              v-model="mainCode"
              :options="mainCodeList"
              :settings="{allowClear: true}"
              style="min-width:80px"
          />
        </b-col>
        <b-col cols="3" v-if="mainCode==1">
          <Select2
              placeholder="Sub"
              v-model="subCode"
              :options="subCodeList"
              :settings="{allowClear: true}"
              style="min-width:80px"
          />
        </b-col>
        <b-col cols="3">
          <b-form-datepicker
            :date-format-options="{
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            }"
            locale="vi-VN"
            v-model="fromDate"
          />
        </b-col>
        <b-col cols="3">
          <b-form-datepicker
            :date-format-options="{
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            }"
            locale="vi-VN"
            v-model="toDate"
          />
        </b-col>
      </b-row>
    </b-col>
    <b-col
      v-else
      class="content-header-right text-md-right d-md-block d-none mb-1"
      md="7"
      cols="12"
    >
<!--      <b-dropdown variant="link" no-caret toggle-class="p-0" right>-->
<!--        <template #button-content>-->
<!--          <b-button-->
<!--            v-ripple.400="'rgba(255, 255, 255, 0.15)'"-->
<!--            variant="primary"-->
<!--            class="btn-icon"-->
<!--          >-->
<!--            <feather-icon icon="SettingsIcon" />-->
<!--          </b-button>-->
<!--        </template>-->

<!--        <b-dropdown-item :to="{ name: 'apps-todo' }">-->
<!--          <feather-icon icon="CheckSquareIcon" size="16" />-->
<!--          <span class="align-middle ml-50">Todo</span>-->
<!--        </b-dropdown-item>-->

<!--        <b-dropdown-item :to="{ name: 'apps-calendar' }">-->
<!--          <feather-icon icon="CalendarIcon" size="16" />-->
<!--          <span class="align-middle ml-50">Calendar</span>-->
<!--        </b-dropdown-item>-->
<!--      </b-dropdown>-->
    </b-col>
  </b-row>
</template>

<script>
import {
  BBreadcrumb,
  BBreadcrumbItem,
  BButton,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormDatepicker,
  BRow,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import moment from "moment";
import EventBus from "@/store/EventBus";
import Select2 from 'v-select2-component';
import vSelect from "vue-select";

export default {
  directives: {
    Ripple,
  },
  components: {
    Select2,
    vSelect,
    BBreadcrumb,
    BBreadcrumbItem,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BButton,
    BFormDatepicker,
  },
  mounted() {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    const currentDay = 1;
    this.fromDate = [currentYear, currentMonth, currentDay].join("-");
    this.toDate = moment().format("YYYY-MM-DD");
  },
  watch: {
    fromDate: function (i, v) {
      EventBus.$emit("dashboardFromDate", this.fromDate);
    },
    toDate: function (i, v) {
      EventBus.$emit("dashboardToDate", this.toDate);
    },
    mainCode: function (i, v) {
      EventBus.$emit("dashboardMainCode", this.mainCode);
    },
    subCode: function (i, v) {
      EventBus.$emit("dashboardSubCode", this.subCode);
    },
  },
  data() {
    return {
      fromDate: "",
      toDate: "",
      mainCode:null,
      subCode:null,
      mainCodeList:[
        {id:1,text:'Website'},
        {id:2,text:'My iTel'},
        {id:3,text:'TikTok Shop'},
        {id:4,text:'Lazada'},
        {id:5,text:'Shopee'},
        {id:6,text:'Momo'},
      ],
      subCodeList:[
        {id:1,text:'Non-Paid'},
        {id:2,text:'Affiliate'},
        {id:3,text:'Ads'}
      ],
    };
  },
};
</script>
<style>
.select2-selection__clear{
  font-size: 20px;
  margin-right: 3%;
}
</style>
